import type Carrier from '~/types/Carrier';

import { type CarrierFormType } from '~/pages/Settings/Carriers/CarrierForm/CarrierForm';
import { armorAPI } from '~/services/api';

export const fetchCarrierFormFields = (carrier: Carrier, formType: CarrierFormType) =>
  armorAPI.request({
    data: {
      carrier: carrier.providerToken,
      form_type: formType,
    },
    method: 'POST',
    url: '/setting/carrier-params',
  });
